module.exports = __webpack_public_path__ + "static/media/upload.80cbdddc.svg";